import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { firebaseConfig } from '@/config';
import * as authProviders from './authProviders';

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const storage = getStorage(app);

auth.useDeviceLanguage();

const providers = authProviders;

export {
  app,
  analytics,
  auth,
  storage,
  providers,
};
